/** Shared Admin Panel button design tokens. */
export const adminButtonBaseSx = {
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: 600,
  boxShadow: 'none',
  gap: '8px',
  '&:focus-visible': {
    outline: '2px solid rgba(63, 122, 42, 0.45)',
    outlineOffset: '2px',
  },
};

export const adminButtonSizes = {
  sm: {
    minHeight: 34,
    px: 1.5,
    py: 0.5,
    fontSize: '0.78rem',
  },
  md: {
    minHeight: 40,
    px: 2.25,
    py: 0.875,
    fontSize: '0.875rem',
  },
  lg: {
    minHeight: 44,
    px: 2.75,
    py: 1,
    fontSize: '0.9375rem',
  },
};

export const adminResetButtonSx = (active) =>
  active
    ? {
        borderColor: 'rgba(63,122,42,0.4)',
        color: '#3f7a2a',
        '&:hover': { borderColor: '#3f7a2a', background: 'rgba(63,122,42,0.06)' },
      }
    : {};

export const adminButtonVariants = {
  primary: {
    muiVariant: 'contained',
    sx: {
      background: 'linear-gradient(135deg, var(--dashboard-primary), #79a83a)',
      color: '#f8faf6',
      border: '1px solid transparent',
      '&:hover': {
        background: 'linear-gradient(135deg, #356922, #6b9634)',
        boxShadow: '0 10px 24px rgba(63, 122, 42, 0.18)',
      },
      '&:disabled': {
        background: '#d6d3d1',
        color: '#a8a29e',
      },
    },
  },
  secondary: {
    muiVariant: 'contained',
    sx: {
      background: 'linear-gradient(135deg, var(--dashboard-secondary), #7aa8fb)',
      color: '#f8fbff',
      border: '1px solid transparent',
      '&:hover': {
        background: 'linear-gradient(135deg, #4f78c9, #6890df)',
        boxShadow: '0 10px 24px rgba(95, 142, 230, 0.18)',
      },
      '&:disabled': {
        background: '#d6d3d1',
        color: '#a8a29e',
      },
    },
  },
  outline: {
    muiVariant: 'outlined',
    sx: {
      borderColor: '#d6d3d1',
      color: '#57534e',
      background: '#fff',
      fontWeight: 500,
      '&:hover': {
        borderColor: '#a8a29e',
        background: '#f5f5f4',
      },
      '&:disabled': {
        borderColor: '#e7e5e4',
        color: '#a8a29e',
        background: '#fafaf9',
      },
    },
  },
  danger: {
    muiVariant: 'outlined',
    sx: {
      borderColor: '#fecaca',
      color: '#dc2626',
      background: '#fff',
      fontWeight: 500,
      '&:hover': {
        borderColor: '#f87171',
        background: '#fff1f2',
      },
      '&:disabled': {
        borderColor: '#fecaca',
        color: '#fca5a5',
        background: '#fff',
      },
    },
  },
  dangerSolid: {
    muiVariant: 'contained',
    sx: {
      background: '#dc2626',
      color: '#fff',
      border: '1px solid transparent',
      '&:hover': {
        background: '#b91c1c',
        boxShadow: '0 10px 24px rgba(220, 38, 38, 0.18)',
      },
      '&:disabled': {
        background: '#fca5a5',
        color: '#fff',
      },
    },
  },
  ghost: {
    muiVariant: 'text',
    sx: {
      color: '#57534e',
      background: 'rgba(248, 251, 245, 0.96)',
      fontWeight: 500,
      '&:hover': {
        background: '#f5f5f4',
      },
      '&:disabled': {
        color: '#a8a29e',
        background: 'transparent',
      },
    },
  },
};
